// @ts-strict-ignore
import * as React from 'react';
import { SpinnerReact } from 'common/components/spinner';
import { SpinnerSize } from 'common/components/spinner/types';
import { SetupGuideContext, Step } from '../types';
import { Scrollable } from '../components/scroll-manager';
import styles from '../index.module.styl';
import { SideNavPhase2 } from '../components';
import { ConnectSDK, StartCards, VerifyConnection } from '../steps';
const STEP_COMPONENTS = {
  [Step.Connect]: ConnectSDK,
  [Step.Verify]: VerifyConnection,
  default: StartCards
};
const Content = React.memo((props: {
  step: Step;
}) => {
  const Component = STEP_COMPONENTS[props.step] || STEP_COMPONENTS.default;
  return <Component />;
});
export const ModalContentPhase2 = props => {
  const {
    modalManager,
    step
  } = React.useContext(SetupGuideContext);
  const {
    closeModal
  } = modalManager;
  const wrapperEl = React.useRef<HTMLDivElement>(null);
  React.useLayoutEffect(() => {
    if (wrapperEl.current) {
      wrapperEl.current.scrollTo({
        top: 0
      });
    }
  }, [step]);
  return <div className={styles.layout} data-sentry-component="ModalContentPhase2" data-sentry-source-file="modal-content-phase2.tsx">
      <SideNavPhase2 onClose={() => {
      closeModal();
    }} data-sentry-element="SideNavPhase2" data-sentry-source-file="modal-content-phase2.tsx" />
      <Scrollable className={styles.rhs} ref={wrapperEl} data-sentry-element="Scrollable" data-sentry-source-file="modal-content-phase2.tsx">
        {props.isLoading ? <div className={styles.spinner}>
            <SpinnerReact size={SpinnerSize.Large} />
          </div> : <Content step={step} />}
      </Scrollable>
    </div>;
};